/* KimBangGu theme — tiny, no dependencies. */
(function () {
  // Mobile menu
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var d = document.getElementById('MenuDrawer');
    if (!d) return;
    var open = d.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  // Product gallery thumbs
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-thumb]');
    if (!b) return;
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = b.getAttribute('data-thumb');
    main.removeAttribute('srcset');
    b.parentElement.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
  });
  // Quantity buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
  });
  // Variant select -> hidden id + price
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-variant-select]');
    if (!s) return;
    var form = s.closest('form');
    var opt = s.options[s.selectedIndex];
    form.querySelector('[name="id"]').value = s.value;
    var price = document.querySelector('[data-price]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { var ok = opt.dataset.available === 'true'; btn.disabled = !ok; btn.querySelector('span').textContent = ok ? btn.dataset.addLabel : btn.dataset.soldLabel; }
    var url = new URL(window.location.href); url.searchParams.set('variant', s.value); history.replaceState({}, '', url);
  });
})();
